module.exports = __webpack_public_path__ + "85da253372860b2245671d4c9f4f4c3f.fbx";